<script>
import BlogPostFiltersComponent from '../../components/pagesbuilder/dynamic-components/BlogPostFiltersComponent.vue';
import PreviewComponent from "./PreviewComponent";
import { debounce } from "lodash";

export default {
    name: "PreviewBlogPostFiltersComponent",
    mixins: [
            PreviewComponent,
            BlogPostFiltersComponent
    ],
    computed: {
        showCategories(){
            if(!this.getPrimaryNodeState){
                return false;
            }
            return this.getPrimaryNodeState.filters?.categories && this.blogPostCategories.length > 0;
        },
    },
    methods: {
        selectCategory(category){
            if(this.selectedCategory == category){
                category = null;
            }
            this.selectedCategory = category;
            this.contextWrapper.getPrimaryNodeState.selectCategory(category);
        },
        setSearchQuery: debounce(function(event){
              const search = event.target.value;
              this.selectedCategory = null;
                if(search.length < 3){
                    this.contextWrapper.getPrimaryNodeState.setSearchQuery(null);
                    return;
                }

                this.contextWrapper.getPrimaryNodeState.setSearchQuery(search);
        }, 700)
    }
    
}
</script>